var _style, _path, _path2, _polygon, _rect, _polygon2, _path3, _polygon3, _path4, _rect2, _path5, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZimperiumLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.6 256.1",
    style: {
      enableBackground: "new 0 0 490.6 256.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#55BBB0;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#468C89;}\n\t.st2{fill:#55BBB0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.7,61.8c0,0,41.5,12.8,54.6,17.1c2.4,0.8,4.8,2.4,4.8,2.4s-31,13.8-52.8,26.7 c-12.1,7.2-21.5,16.6-21.5,16.6l-34.1-7.7c0,0,7-12.2,18.5-25.2C231.2,77.2,248.7,61.8,248.7,61.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.1,81.3l-23-30.7c0,0-22-3.8-43.9-3.8s-44.1,3.8-44.1,3.8l-23,30.7c0,0,33.5-7.7,67-7.7 C274.7,73.6,308.1,81.3,308.1,81.3 M199.8,117l41.2,35.3l41.2-35.3c0,0-20.6,3.8-41.2,3.8S199.8,117,199.8,117"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "144.3,174 166.8,174 152,196 152,196.1 165.1,196.1 165.1,200.9 142.7,200.9 157.6,179 157.6,178.9  144.3,178.9 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 169.3,
    y: 174,
    className: "st2",
    width: 5.1,
    height: 26.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "178.7,172.8 192.4,186.2 192.4,186.2 206,172.8 206,200.9 200.9,200.9 200.9,184.6 200.8,184.6  192.4,193.1 184,184.6 183.8,184.6 183.9,200.9 178.7,200.9 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.1,192.4h-6.7v8.5h-5.1V174h11.8c5.2,0,9.5,3.9,9.5,9.2C231.6,188.5,227.4,192.4,222.1,192.4 M222.1,179 h-6.7v8.6h6.7c2.3,0,4.2-1.9,4.2-4.3C226.3,180.9,224.5,179,222.1,179"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "254.8,196.1 254.8,200.9 235,200.9 235,174 254.8,174 254.8,179 240.1,179 240.1,185 252.3,185  252.3,189.9 240.1,189.9 240.1,196.1 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274,191.6l4.7,9.4H273l-4.2-8.5h-5.5v8.5h-5.1V174H270c5.2,0,9.5,3.9,9.5,9.2 C279.5,187.1,277.2,190.2,274,191.6 M270,179h-6.7v8.6h6.7c2.3,0,4.2-1.9,4.2-4.3C274.2,180.9,272.3,179,270,179"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 174,
    className: "st2",
    width: 5.1,
    height: 26.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.9,191.6c0,6.2-4.6,10-10.7,10c-6.2,0-10.7-3.8-10.7-10v-17.5h5.1v17.5c0,3.2,2.4,5.4,5.6,5.4 s5.6-2.2,5.6-5.4v-17.5h5.1V191.6z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "318.2,172.8 331.8,186.2 331.9,186.2 345.5,172.8 345.5,200.9 340.4,200.9 340.4,184.6 340.2,184.6  331.8,193.1 323.4,184.6 323.3,184.6 323.3,200.9 318.2,200.9 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimperiumLogo);
export default __webpack_public_path__ + "static/media/zimperium-logo.ea52634ac6778d7079b23d702cec8652.svg";
export { ForwardRef as ReactComponent };